import tasksRoutes from '@/views/Tasks/router';


export default [
  {
    path: '/plans',
    component: () => import(/* webpackChunkName: "plans" */ '@/views/Plans/pages'),
    children: [
      {
        path: '/',
        name: 'Plans',
        component: () => import(/* webpackChunkName: "plans" */ '@/views/Plans/pages/Plans'),
      },
      {
        path: 'list-categories',
        name: 'ListPlansCategories',
        component: () => import(/* webpackChunkName: "plans" */ '@/views/Plans/pages/ListCategories')
      },
      {
        path: 'list-plans',
        name: 'ListPlans',
        component: () => import(/* webpackChunkName: "plans" */ '@/views/Plans/pages/ListPlans')
      },
      {
        path: 'register',
        name: 'RegisterPlans',
        component: () => import(/* webpackChunkName: "plans" */ '@/views/Plans/pages/RegisterPlans')
      },
      {
        path: ':id/edit',
        name: 'EditPlans',
        component: () => import(/* webpackChunkName: "plans" */ '@/views/Plans/pages/RegisterPlans')
      },
      ...tasksRoutes,
    ],
  },
]
